export default "__VITE_ASSET__C_Fl7gGN__"